export const QUERY: string = 'QUERY'
export const ACTIVITY: string = 'ACTIVITY'
